// @flow
import React from 'react';
import { type ContextRouter } from 'react-router-dom';

import UserProducts from 'containers/user/UserProducts';

type Props = ContextRouter & {};

const UserProductsSubpage = ({ match }: Props) => {
  // $FlowFixMe
  return <UserProducts username={match.params.username} tag={match.params.tag} />;
};

export default UserProductsSubpage;



// WEBPACK FOOTER //
// ./src/pages/user/UserProductsSubpage.js